import { createFeature } from "./createFeature";
import { createFeatureHook } from "./createFeatureHook";

interface FeatureRequest {
  name: string;
  version: number;
}

const reportWarning = (
  item: unknown,
  expected: { name: string; type: string },
) => {
  // eslint-disable-next-line no-console
  console.warn(
    `${expected.name} ${item} should be a ${expected.type} but is a ${typeof item} / ${item?.toString?.()}`,
  );
};

const createFeaturesQueryRequest = (
  modulesFeaturesNames: FeatureRequest[][],
  legacyModulesTestAliases: string[][],
) => {
  const activeV1Features = (legacyModulesTestAliases || [[]]).reduce(
    (activeAliases, aliases) => {
      if (Array.isArray(aliases)) {
        aliases.forEach((alias) => {
          if (typeof alias !== "string") {
            reportWarning(alias, { name: "Alias", type: "string" });
            return;
          }
          if (!activeAliases.find((feature) => feature.name === alias)) {
            activeAliases.push({ name: alias, version: 1 });
          }
        });
      }

      return activeAliases;
    },
    [] as Array<FeatureRequest>,
  );
  const activeFeaturesAcc = (modulesFeaturesNames || [[]]).reduce(
    (activeFeatures, features) => {
      if (Array.isArray(features)) {
        features.forEach((feature) => {
          if (!feature || typeof feature !== "object") {
            reportWarning(feature, { name: "Feature", type: "object" });
            return;
          }
          if (typeof feature.name !== "string") {
            reportWarning(feature.name, {
              name: "Feature name",
              type: "string",
            });
            return;
          }
          const sameFeatures = activeFeatures.filter(
            (existentFeature) => existentFeature.name === feature.name,
          );
          if (
            sameFeatures.some(
              (sameFeature) => sameFeature.version === feature.version,
            )
          ) {
            return;
          }
          activeFeatures.push(feature);
        });
      }

      return activeFeatures;
    },
    activeV1Features,
  );
  return {
    aliases: activeFeaturesAcc,
  };
};

export { createFeature, createFeatureHook, createFeaturesQueryRequest };
